<template>
 <b-overlay
    opacity="0.75"
    spinner-variant="primary"
    :show="$root.$data.bsLoader"
  >
    <div class="edit-user-profile">
        <!-- navbar -->
        <nav-bar/>

        <div class="user-settings">
            <!-- tabs bar -->
            <div class="change-details">
                <tabs-bar></tabs-bar>
            </div>

            <!-- form -->
            <div class="user-form">
                <b-col class="text-toggle">
                    <h1 class="head-title font-weight-bold text-center mb-3">Team Members</h1>
                    <a href="#!" class="menu" @click="opensidebar()"><i class="fas fa-bars fa-2x"></i></a>
                </b-col>

                 <div class="datagrid mb-4 mt-4">
                        <div class="datagrid-body">
                            <b-table
                                :busy="this.$root.loading"
                                :items="tableItems"
                                :fields="tableFields"
                                sort-icon-left
                                hover
                                responsive
                            >
                                <template v-slot:table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner
                                            class="align-middle"
                                            :variant="'primary'"
                                        ></b-spinner>
                                    </div>
                                </template>
                                   <template v-slot:cell(Role)="row">
                                    <!-- <b-form-select v-if="row.item.Role != 'Owner'" v-model="row.item.Role" :options="roleOptions" size="sm" @change="changeRole(row.item.id, row.item.Role)"></b-form-select>
                                    <span v-if="row.item.Role == 'Owner'">{{row.item.Role}}</span> -->
                                    <div v-if="$store.state.authenticatedUserData.business_role.name == 'Staff'">
                                        <span v-if="row.item.Role == 1">SuperAdmin</span>
                                        <span v-if="row.item.Role == 2">Admin</span>
                                        <span v-if="row.item.Role == 3">Staff</span>
                                    </div>

                                     <div v-if="$store.state.authenticatedUserData.business_role.name == 'SuperAdmin' || $store.state.authenticatedUserData.business_role.name == 'Admin'">

                                        <span v-if="row.item.Role == 1">SuperAdmin</span>
                                        <!-- <span v-else-if="row.item.Role == 2">Admin</span> -->

                                        <b-form-select v-else v-model="row.item.Role" :options="roleOptions" size="sm" @change="changeRole(row.item.id, row.item.Role)"></b-form-select>

                                    </div>
                                </template>
                            </b-table>

                        </div>
                        <div class="datagrid-footer" v-if="lastPage > 1">
                            <b-pagination
                                pills
                                align="right"
                                :total-rows="total"
                                v-model="currentPage"
                                :page-count="lastPage"
                                :per-page="perPage"
                                :hide-goto-end-buttons="true"
                            ></b-pagination>
                        </div>
                </div>
            </div>
        </div>

    </div>
 </b-overlay>
</template>

<script>
import TabsBar from "../includes/TabsBar.vue";
import NavBar from "../includes/NavBar.vue";
import moment from "moment";
import Swal from 'sweetalert2';
import toggleMixin from "../../../../mixins/toggleMixin.js";


export default {
    props: ["form", "step", "sidebarListLinks",],
    components: {
        TabsBar,NavBar
    },
    mixins: [toggleMixin],
     data() {
        return {
            currentPage: 1,
            total: 0,
            perPage: 50,
            lastPage: 1,
            tableItems: [],
            tableFields: [
                {key: '', sortable: true},
                {key: 'Name', sortable: true},
                {key: 'Email', sortable: true},
                {key: 'LastActive', sortable: true},
                {key: 'Position', sortable: true},
                {key: 'Role', sortable: true},
            ],
            filterQuery: "",
            filterManagerOptions: [],
            roleOptions: [
                { value: 2, text: 'Admin' },
                { value: 3, text: 'Staff' },
            ]
        };
    },
    mounted() {
        this.getTeamMember();
    },
    methods: {
        getTeamMember(){
             this.$root.$data.bsLoader = true;
            axios
            .post("api/contractor/team-members")
            .then((response) => {
                this.tableItems = _.map(response.data.team_members, function (teamMember) {
                    return {
                        id: teamMember.id,
                        Name: teamMember.first_name + ' ' + teamMember.last_name,
                        Email: teamMember.email,
                        LastActive: teamMember.last_active_at? moment(teamMember.last_active_at).subtract(4, 'hours').subtract(15, 'minutes').fromNow() : 'Not Logged In',
                        Position: teamMember.role_id == 2 ? 'Manager' : 'Contractor',
                        // Role: teamMember.pivot.is_business_admin == 1 ? 'Admin' : 'User',
                        Role: teamMember.user_business_role.id,
                        business_role_info: teamMember.user_business_roles
                    };
                 });

                //Shifting at the beginnning of table row
                this.tableItems.unshift({
                    id: this.$store.state.authenticatedUserData.user.id,
                    Name: this.$store.state.authenticatedUserData.user.full_name,
                    LastActive: 'Currently Logged In',
                    Email: this.$store.state.authenticatedUserData.user.email,
                    Position: this.$store.state.authenticatedUserData.user.role_id == 2 ? 'Manager' : 'Contractor',
                    Role: this.$store.state.authenticatedUserData.business_role.id,
                    business_role_info: this.$store.state.authenticatedUserData.business_role
                });
                 this.$root.$data.bsLoader = false;
            }).catch((error) => {
                 this.$root.$data.bsLoader = false;
            });
        },
        changeRole(teammember_id, role){
            this.$root.$data.bsLoader = true;
            axios
                .post("api/contractor/change-team-member-role",{
                    user_id : teammember_id,
                    business_role_id: role
                })
                .then((response) => {
                    Swal.fire({
                        title: "Role Updated",
                        icon: "success",
                        timer: 3000,
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                     });
                    this.$root.$data.bsLoader = false;
                }).catch((error) => {
                    this.$root.$data.bsLoader = false;
                });
        },
        opensidebar(){
            let sidebarDetails = document.querySelector('.change-details');
            this.toggleProfile(sidebarDetails)
        }
    }
}
</script>
<style>
.datagrid
{
    border-radius: 8px;
    box-shadow: 1px 3px 10px rgb(233 239 244 / 81%);

}
.table thead th
{
    border-bottom: none;
    border-top: none;
}
.team-member thead {
    background: #fff;
    color: #000;
}
.team-member thead th td{
    border:none
}
.team-member li{
    list-style: none;
    padding-bottom: 10px;
}
.team-member li h5{
    color: #000;
}
</style>

<style scoped>
@media screen and (max-width: 600px) {
    .datagrid {
        width: 80%;
        max-width: 500px;
    }
}
</style>
